import api from '../../../utils/api';
import { INVENTORY_MANUAL_UPDATE_ACTIONS } from '../../constants/updateInventoryManualActions';

export function updateInventoryQuantitiesViaFileUpload({ supplierId, s3FilePath }) {
  return api.post(`/suppliers/${supplierId}/variants/inventory-manual-updates`, {
    s3FilePath,
    action: INVENTORY_MANUAL_UPDATE_ACTIONS.updateQuantitiesViaCsvUpload,
  });
}

export function updateVariantBuffersViaFileUpload({ supplierId, s3FilePath }) {
  return api.post(`/suppliers/${supplierId}/variants/inventory-buffers`, {
    s3FilePath,
    action: INVENTORY_MANUAL_UPDATE_ACTIONS.setVariantBuffersViaCSV,
  });
}
